import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectReferencePhoto} from '../models/project-reference-photo';
import {PhotoFocus} from '../models/photo-focus';
import {PhotoPositionsRequest} from '../models/photo-positions.request';

export interface ProjectReferencePhotoService {
    getPhotos(projectReferenceId: number): Observable<ProjectReferencePhoto[]>;
    postPhoto(projectReferenceId: number, file: File): Observable<any>;
    deletePhoto(id: number): Observable<void>;
    putFocusPoint(id: number, focus: PhotoFocus): Observable<ProjectReferencePhoto>;
    putPrimaryPhoto(projectReferenceId: number, projectReferencePhotoId: number): Observable<any>;
    putPositions(projectReferenceId: number, positions: PhotoPositionsRequest[]): Observable<ProjectReferencePhoto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectReferencePhotoServiceImpl implements ProjectReferencePhotoService {
    protected http = inject(HttpClient);


    getPhotos(projectReferenceId: number): Observable<ProjectReferencePhoto[]> {
        return this.http.get<ProjectReferencePhoto[]>(`/api/v1/project-references/${projectReferenceId}/photos`);
    }

    postPhoto(projectReferenceId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<ProjectReferencePhoto>(`/api/v1/project-references/${projectReferenceId}/photos`, formData);
    }

    putPositions(projectReferenceId: number, positions: PhotoPositionsRequest[]): Observable<ProjectReferencePhoto[]> {
        return this.http.put<ProjectReferencePhoto[]>(`/api/v1/project-references/${projectReferenceId}/photo-positions`, positions);
    }

    putFocusPoint(id: number, focus: PhotoFocus): Observable<ProjectReferencePhoto> {
        return this.http.put<ProjectReferencePhoto>(`/api/v1/project-reference-photos/${id}/focus-point`, focus);
    }

    deletePhoto(id: number): Observable<void> {
        return this.http.delete<void>(`/api/v1/project-reference-photos/${id}`);
    }

    putPrimaryPhoto(projectReferenceId: number, projectReferencePhotoId: number): Observable<any> {
        const url = `/api/v1/project-references/${projectReferenceId}/photos/${projectReferencePhotoId}/primary-photo`;

        return this.http.put(url, null);
    }
}
